import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import EN_US from './translations/en-us/index.translation'

/**
 * Different languages that are imported.
 * At the moment we are only using ES_US
 */
const resources = {
  EN_US,
}

/**
 * Initialization of the language is set
 */
i18n.use(initReactI18next).init({
  resources,
  lng: 'EN_US',
})

export default i18n
